import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { WorkspaceDocVersion } from '@workspaces/models/versions';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { VersionMetaDialogComponent } from '@workspaces/components/version-meta-dialog/version-meta-dialog.component';

import { VersionRestoreDialogComponent } from '@workspaces/components/version-restore-dialog/version-restore-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';
import { RequiredRoleDirective } from '@workspaces/utils/workspace-guard.directive';

@Component({
  selector: 'app-version-list-item',
  templateUrl: './version-list-item.component.html',
  styleUrls: ['./version-list-item.component.scss', '../../../global-workspace-styles.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatDividerModule,
    MatIconModule,
    MatChipsModule,
    DatePipe,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    RequiredRoleDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VersionListItemComponent {
  @Input({ required: true }) version!: WorkspaceDocVersion;
  @Input({ required: true }) workspaceId = '';
  @Input({ required: true }) currentSelectedVersionId: string | null = null;
  @Input({ required: true }) isLatestInDate = false;
  @Input() noVersionToCompare = false;

  @Input() otherVersionsCount = 0;
  @Input() isExpanded = false;

  @Output() versionClicked = new EventEmitter<string>();
  @Output() expandToggled = new EventEmitter<void>();
  private readonly sub = new Subscription();
  constructor(public readonly dialog: MatDialog) {}

  openUpdateVersion() {
    this.dialog.open(VersionMetaDialogComponent, {
      data: {
        workspaceId: this.workspaceId,
        version: this.version
      },
      minWidth: '400px'
    });
  }

  restoreVersion() {
    this.dialog.open(VersionRestoreDialogComponent, {
      data: {
        workspaceId: this.workspaceId,
        version: this.version
      },
      minWidth: '400px'
    });
  }
}
